import { MainLayoutQuery } from "@/lib/sanity/queries";
import dynamic from "next/dynamic";
import HomeLink from "./HomeLink";
import Navigation from "./Navigation";
import { Container } from "./styles";

// TODO: understand why this component throws on SSR
const Content = dynamic(() => import("./Content"), { ssr: false });

type Props = {
  navigation: MainLayoutQuery["footer"]["navigation"];
  content?: MainLayoutQuery["footer"]["content"];
};

const Footer: React.FC<Props> = (props) => {
  const { navigation, content } = props;
  const HomeLinkComponent = HomeLink as any;
  const NavigationComponent = Navigation as any;
  const ContentComponent = Content as any;
  return (
    <Container>
      <HomeLinkComponent />
      <NavigationComponent items={navigation.items} />
      {content && <ContentComponent blocks={content} />}
    </Container>
  );
};

export default Footer;
